import React, { useEffect, useState } from "react";
import axios from "axios";
import { NGROK } from "../../../APIs";



const BloodHoundQueries = ({ tenantName, selectedQuery }) => {
  const [loading, setLoading] = useState(false);
  const [queries, setQueries] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectQuery, setSelectQuery] = useState(null);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
  const fetchBlodHoundQueries = async (isFirst = false, tenantName) => {
    if (isFirst) setLoading(true);
    try {
      const response = await axios.get(
        `${NGROK}/api/bloodhound/query/get-all?tenantName=${tenantName}`,
      );
      if (response?.data) {
        setQueries(response?.data);
        if (response.data.length > 0) {
          setSelectQuery(response.data[0]);
          selectedQuery(response.data[0]);
        }
      }
    } catch (e) {
      setQueries([]);
    }

    setLoading(false);
  };

  const filterequeryDatas = queries?.filter((query) =>
    query.description.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  useEffect(() => {
    if (tenantName != null) fetchBlodHoundQueries(true, tenantName);
  }, [tenantName]);

  return (
    <div className="h-full flex flex-col">
      <div className="mb-3">
       
        <input
          type="text"
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-700 rounded-md bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring focus:border-blue-500 mb-2"
          placeholder="Search..."
          value={searchQuery}
          onChange={handleSearchChange}
        />
      </div>
      <div className="flex-1 overflow-auto">
        <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
          <thead className="bg-gray-100 dark:bg-gray-700">
            <tr>
              <th className="px-4 py-2 text-left text-sm font-semibold text-gray-900 dark:text-gray-100">Query Description</th>
            </tr>
          </thead>
          <tbody className="bg-white dark:bg-gray-800">
            {loading ? (
              <tr>
                <td className="px-4 py-4 text-center" colSpan={1}>
                  <span className="text-gray-500 dark:text-gray-400">Loading...</span>
                </td>
              </tr>
            ) : filterequeryDatas.length === 0 ? (
              <tr>
                <td className="px-4 py-4 text-center" colSpan={1}>
                  <span className="text-gray-500 dark:text-gray-400">No queries found.</span>
                </td>
              </tr>
            ) : (
              filterequeryDatas.map((item) => (
                <tr
                  key={item.id}
                  className={`cursor-pointer ${selectQuery?.id === item.id ? 'bg-blue-100 dark:bg-blue-900' : ''}`}
                  onClick={() => {
                    setSelectQuery(item);
                    selectedQuery(item);
                  }}
                >
                  <td className="px-4 py-2 text-base text-gray-900 dark:text-gray-100">
                    {item.description}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BloodHoundQueries;
